<template>
  <div class="msg-background">
    <el-tabs type="border-card">
      <el-tab-pane label="原始报文">
        <el-input type="textarea" :rows="30" v-model="this.content.info"></el-input>
      </el-tab-pane>
      <el-tab-pane label="传输报文">
        <el-input type="textarea" :rows="30" v-model="this.content.trans"></el-input>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "FileContent",
  props: { content: Object }
}
</script>
<style scoped>
.msg-background {
  padding: 10xp;
  background-color: #ddefe9;
  width: auto;
}
.tarea {
  height: 200px;
}
</style>